import type { ISODateTimeString } from '../BrandedTypes'
import type { FieldEntityTarget, FieldOrigin } from '../FieldConfiguration'

export const FieldConfiguration = {
  V1: {
    CustomFieldValuesUpdated:
      'FieldConfiguration.V1.CustomFieldValuesUpdatedEvent',
    FieldConfigChanged: 'FieldConfiguration.V1.FieldConfigChanged',
    CustomFieldAdded: 'FieldConfiguration.V1.CustomFieldAdded',
    CustomFieldUpdated: 'FieldConfiguration.V1.CustomFieldUpdated',
    CustomFieldRemoved: 'FieldConfiguration.V1.CustomFieldRemoved',
    CustomFieldsOrderChanged: 'FieldConfiguration.V1.CustomFieldsOrderChanged'
  }
} as const

export type CustomFieldValuesUpdatedSignalRPayload = {
  entityTarget: FieldEntityTarget
  entityTargetId: string
  occuredAt: ISODateTimeString
}

export type CustomFieldAddedSignalRPayload = {
  id: string
  occuredAt: ISODateTimeString
}

export type CustomFieldUpdatedSignalRPayload = {
  id: string
  occuredAt: ISODateTimeString
}

export type CustomFieldRemovedSignalRPayload = {
  id: string
  occuredAt: ISODateTimeString
}

export type CustomFieldsOrderChangedSignalRPayload = {
  entityTarget: FieldEntityTarget
  occuredAt: ISODateTimeString
}

export type FieldConfigChangedSignalRPayload = {
  entityTarget: FieldEntityTarget
  fieldName: string
  origin: FieldOrigin
  occuredAt: ISODateTimeString
}
